import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://aooragcwnmztmdedhuax.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFvb3JhZ2N3bm16dG1kZWRodWF4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE5OTc2MzgsImV4cCI6MjA2NzU3MzYzOH0.oW-1TR9FdTtffU-sweKDXTaFOn_9Rq7uH8UzKgAKrPU';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);